import './index.css';
import './static/scss/master.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import NectosDash from './NectosDash';

ReactDOM.render(
	<React.StrictMode>
		<NectosDash />
	</React.StrictMode>,
	document.getElementById('root'),
);
const preloader = document.getElementById('preloader');
if (preloader) {
	preloader.style.opacity = '0'; 
	setTimeout(() => {
		preloader.style.display = 'none';
	}, 500); 
}
reportWebVitals();
